<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { marked } from 'marked';
  import { getAppConfig } from '../../../../common/config/app-config';
  import HorizontalDivider from '../../../common/components/HorizontalDivider.svelte';
  import { getBlogImageAltTextFromUrl } from '../../services/blog-data-services';

  export let data: any;
  const { lang } = getAppConfig();
</script>

{#if data}
  <div class="blog-detail-variant-container">
    <LayoutGrid>
      <Cell
        class="blog-detail-image-container"
        style={`order: ${data?.designType === 'Right' ? 1 : 0}`}
        spanDevices={{ desktop: 6, tablet: 4, phone: 4 }}
      >
        <div class="blog-detail-image">
          <img
            class={`${data?.designType === 'Right' ? 'right-image' : 'left-image'}`}
            src={`${data?.image}?fmt=auto`}
            alt={getBlogImageAltTextFromUrl(data?.image)}
          />
        </div>
      </Cell>
      <Cell class="blog-detail-text-container" spanDevices={{ desktop: 6, tablet: 4, phone: 4 }}>
        <div class="blog-detail-text">
          {#if data?.title}
            <h5 class="blog-detail-title">
              {data?.title}
            </h5>
          {/if}
          {#if data?.descriptionAr || data?.descriptionEn}
            <p class="blog-detail-description">
              {@html lang === 'en' ? marked(`${data?.descriptionEn}`) : marked(`${data?.descriptionAr}`)}
            </p>
          {/if}
        </div>
      </Cell>
    </LayoutGrid>
  </div>
  {#if data?.divider}
    <HorizontalDivider height="2" />
  {/if}
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .blog-detail-variant-container {
    :global {
      .mdc-layout-grid {
        padding: 0;
      }
      .mdc-layout-grid__inner {
        gap: 90px;
      }
      .blog-detail-text-container {
        padding: 55px 0;
      }
    }
    .blog-detail-text {
      display: flex;
      flex-direction: column;
      gap: 30px;
      color: $neutral-dark-01;
      .blog-detail-title {
        font-size: 30px;
        font-weight: 700;
        line-height: 40px;
        margin: 0;
      }
      .blog-detail-description {
        margin: 0;
        :global {
          p {
            font-size: 20px;
            font-weight: 400;
            line-height: 26px;
            margin: 0;
            color: $neutral-dark-01;
            a {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .right-image {
      border-radius: 0px 20px 20px 0px;
    }
    .left-image {
      border-radius: 20px 0px 0px 20px;
    }
  }
</style>
